// import React from 'react';
// import { Container, Row, Col, Image } from 'react-bootstrap';

// import "../Styles/ProductStyle.css";
// import productImage from '../Assets/aiskinan.jpeg';
// import productImage1 from '../Assets/airev1.png';  // Replace with your actual image
// import backgroundImage from '../Assets/imgai.png'; // Replace with your background image

// const AISkinAnalyzer = () => {

//   const handleOpenPDF = () => {
//     // Replace 'path/to/your-manual.pdf' with the actual path to your PDF file
//     window.open("https://romanqadir.github.io/jsonapi/pdfreveal.pdf");
//   };

//   return (
//     <div className="ai-skin-analyzer-page">
//       {/* Hero Section with Branding */}
//       <section 
//         className="hero-section" 
//         style={{ backgroundImage: `url(${backgroundImage})` }}
//       >
//         <Container>
//           <Row className="align-items-center">
//             <Col md={6} className="hero-content">
//               <h1 className="product-title">EPILYUM AI REVEAL</h1>
//               <h2 className="product-subtitle">Artificial Intelligence Skin Analyzer</h2>
//             </Col>
//             <Col md={6} className="text-center">
//               <Image src={productImage} fluid className="product-hero-image" />
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {/* Product Description Section */}
//       <section className="product-description">
//         <Container>
//           <Row>
//             <Col>
//               <p className="intro-text">
//                 In today's fast-paced world with a research and development focus on solving skin problems, 
//                 Epilyum AI Reveal integrates eight spectral imaging technologies and can professionally 
//                 and objectively analyze seventeen problems of facial skin with flexible operations. 
//                 The original intention of the research and development is to take photos and analyze reports 
//                 with just one click, making it more convenient to operate and give beauty design.
//               </p>
              
//               <h3 className="feature-heading">Professional Skin Analysis</h3>
              
//               <p className="feature-text">
//                 Harnessing the power of 8-spectrum imaging technologies and intelligent AI algorithms, 
//                 EPILYUM AI REVEAL provides a comprehensive, data-driven analysis of your skin. 
//                 It identifies up to 17+ skin concerns including wrinkles, acne, spots, pores, 
//                 pigmentation, and more—instantly and accurately.
//               </p>
              
//               <p className="feature-text">
//                 Based on your skin analysis, our system recommends the most suitable treatment 
//                 and skincare products, ensuring optimal effectiveness and quality. Designed for ease-of-use, 
//                 EPILYUM AI REVEAL offers one-click photo capture and analysis, multilingual support, 
//                 and intuitive interface navigation—ideal for both clinics and beauty professionals.
//               </p>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {/* Product Image Gallery Section */}
//       <section className="product-gallery">
//         <Container>
//           <Row>
//             <Col md={6} className="mb-4">
//               <Image src={productImage} fluid className="product-feature-image" />
//               <p className="image-caption">EPILYUM AI REVEAL - Front View</p>
//             </Col>
//             <Col md={5} className="mb-4">
//               <Image src={productImage1} fluid className="product-feature-image" />
//               <p className="image-caption">EPILYUM AI REVEAL - In Use</p>
//             </Col>
//           </Row>
//         </Container>
//       </section>

    
    
//       {/* Key Features Section */}
// <section className="key-features">
//   <Container>
//     <h3 className="section-title">Key Features</h3>
//     <Row>
//       <Col md={4} className="feature-box">
//         <div className="feature-icon">📊</div>
//         <h4>Comprehensive Analysis</h4>
//         <p>17+ skin concerns identified with precision</p>
//       </Col>
//       <Col md={4} className="feature-box">
//         <div className="feature-icon">⚡</div>
//         <h4>Instant Results</h4>
//         <p>One-click photo capture and immediate analysis</p>
//       </Col>
//       <Col md={4} className="feature-box">
//         <div className="feature-icon">🌐</div>
//         <h4>Multilingual Support</h4>
//         <p>User-friendly interface in multiple languages</p>
//       </Col>
//     </Row>
//   </Container>
// </section>

// {/* New Features Image Section */}
// <section className="features-image-section py-5">
//   <Container>
//     <Row className="justify-content-center">
//       <Col md={10} lg={8}>
//         <Image 
//           src={require('../Assets/aitest.png')} 
//           fluid 
//           className="features-display-image"
//           alt="EPILYUM AI REVEAL All Features"
//         />
//         <p className="text-center mt-3 image-caption">
//           EPILYUM AI REVEAL in action - showing comprehensive skin analysis interface
//         </p>
//       </Col>
//     </Row>
//   </Container>
// </section>
// {/* Catalog Download Section */}
// <section className="catalog-section py-5 bg-light">
//   <Container>
//     <Row className="justify-content-center">
//       <Col md={8} className="text-center">
//         <h3 className="section-title mb-4">Download Product Catalog</h3>
//         <p className="lead mb-4">
//           Get detailed specifications and technical information about EPILYUM AI REVEAL
//         </p>
        
//         <div className="catalog-preview mb-4">
//           <Image 
//             src={require('../Assets/airev.png')} 
//             fluid 
//             className="catalog-thumbnail shadow"
//             alt="Catalog Preview"
//             style={{ maxHeight: '300px', border: '1px solid #ddd' }}
//           />
//         </div>
        
//         <a onClick={handleOpenPDF}
//           href={handleOpenPDF} 
//           className="btn btn-primary btn-lg download-btn"
//           target="_blank" 
//           rel="noopener noreferrer"
//           download="EPILYUM-AI-REVEAL-Catalog.pdf"
          
//         >
//           <i className="fas fa-download me-2"></i> Download Full Catalog (PDF)
//         </a>
        
//         <p className="mt-3 text-muted">
//           <small>PDF File Size: 2.4MB</small>
//         </p>
//       </Col>
//     </Row>
//   </Container>
// </section>

//     </div>
//   );
// };

// export default AISkinAnalyzer;




import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import "../Styles/ProductStyle.css";
import productImage from '../Assets/aiskinan.jpeg';
import productImage1 from '../Assets/airev1.png';
import backgroundImage from '../Assets/imgai.png';

const AISkinAnalyzer = () => {
  // useEffect(() => {
  //   AOS.init({
  //     duration: 800,
  //     easing: 'ease-in-out',
  //     once: false
  //   });
  // }, []);

  // const handleOpenPDF = () => {
  //   window.open("https://romanqadir.github.io/jsonapi/pdfreveal.pdf");
  // };
  const handleOpenPDF = () => {
  // Using fetch to get the file as blob
  fetch("https://romanqadir.github.io/jsonapi/pdfreveal.pdf")
    .then(response => response.blob())
    .then(blob => {
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'AI-Reveal.pdf'; // Specify the filename for download
      
      // Append to body, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the blob URL
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(error => {
      console.error('Download failed:', error);
      // Fallback to opening in new tab if download fails
      window.open("https://romanqadir.github.io/jsonapi/pdfreveal.pdf", '_blank');
    });
};

  return (
    <div className="ai-skin-analyzer-page">
      {/* Hero Section with Enhanced Animation */}
    <section 
        className="hero-section" 
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <Container>
          <Row className="align-items-center" style={{height:"400px"}}>
            <Col md={6} className="hero-content">
              <h1 className="product-title">EPILYUM AI REVEAL</h1>
              <h2 className="product-subtitle">Artificial Intelligence Skin Analyzer</h2>
            </Col>
            <Col md={6} className="text-center">
             
            </Col>
          </Row>
        </Container>
      </section>

      {/* Product Description Section with Animated Cards */}
      <section className="product-description py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title" data-aos="fade-up">
                Revolutionary Skin Analysis Technology
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            <Col md={6} data-aos="fade-up">
              <div className="info-card h-100">
                <div className="card-body">
                  <p className="intro-text">
                    In today's fast-paced world with a research and development focus on solving skin problems, 
                    Epilyum AI Reveal integrates eight spectral imaging technologies and can professionally 
                    and objectively analyze seventeen problems of facial skin with flexible operations.
                  </p>
                </div>
              </div>
            </Col>
            
            <Col md={6} data-aos="fade-up" data-aos-delay="100">
              <div className="info-card h-100">
                <div className="card-body">
                  <p className="intro-text">
                    The original intention of the research and development is to take photos and analyze reports 
                    with just one click, making it more convenient to operate and give beauty design recommendations 
                    with clinical precision.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Professional Analysis Section with Floating Elements */}
      <section className="professional-analysis py-5 bg-gradient">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0" data-aos="fade-right">
              <h3 className="feature-heading display-5 mb-4">
                Professional <span className="text-highlight">Skin Analysis</span>
              </h3>
              
              <div className="feature-text-box" data-aos="fade-up">
                <p className="feature-text">
                  Harnessing the power of 8-spectrum imaging technologies and intelligent AI algorithms, 
                  EPILYUM AI REVEAL provides a comprehensive, data-driven analysis of your skin.
                </p>
              </div>
              
              <div className="feature-text-box mt-4" data-aos="fade-up" data-aos-delay="100">
                <p className="feature-text">
                  It identifies up to 17+ skin concerns including wrinkles, acne, spots, pores, 
                  pigmentation, and more—instantly and accurately.
                </p>
              </div>
            </Col>
            
            <Col lg={6} data-aos="fade-left" data-aos-delay="200">
              <div className="analysis-image-container" >
                <Image 
                  src={productImage1} 
                  fluid 
                  className="analysis-image floating-2" 
                />
                <div className="floating-badge badge-1" data-aos="fade-down-right">
                  <span>8-Spectrum Imaging</span>
                </div>
                <div className="floating-badge badge-2" data-aos="fade-down-left">
                  <span>17+ Skin Metrics</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Enhanced Product Gallery with Hover Effects */}
      <section className="product-gallery py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title" data-aos="fade-up">
                EPILYUM AI REVEAL In Action
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            <Col md={6} data-aos="zoom-in">
              <div className="gallery-card">
                <Image 
                  src={productImage} 
                  fluid 
                  className="product-feature-image" 
                />
                <div className="image-overlay">
                  <h5>EPILYUM AI REVEAL</h5>
                  <p>Front View</p>
                </div>
              </div>
            </Col>
            
            <Col md={6} data-aos="zoom-in" data-aos-delay="100">
              <div className="gallery-card">
                <Image 
                  src={productImage1} 
                  fluid 
                  className="product-feature-image" 
                />
                <div className="image-overlay">
                  <h5>Analysis Interface</h5>
                  <p>In Clinical Use</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Animated Key Features Section */}
      <section className="key-features py-5">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <h2 className="section-title" data-aos="fade-up">
                Key <span className="text-highlight">Features</span>
              </h2>
              <div className="divider" data-aos="fade-up" data-aos-delay="100"></div>
            </Col>
          </Row>
          
          <Row className="g-4">
            {[
              {
                icon: "📊",
                title: "Comprehensive Analysis",
                text: "17+ skin concerns identified with precision"
              },
              {
                icon: "⚡",
                title: "Instant Results",
                text: "One-click photo capture and immediate analysis"
              },
              {
                icon: "🌐",
                title: "Multilingual Support",
                text: "User-friendly interface in multiple languages"
              }
            ].map((feature, index) => (
              <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <span className="feature-icon">{feature.icon}</span>
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Interactive Features Showcase */}
      <section className="features-image-section py-5 bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} data-aos="zoom-in">
              <div className="features-showcase">
                <Image 
                  src={require('../Assets/aitest.png')} 
                  fluid 
                  className="features-display-image"
                  alt="EPILYUM AI REVEAL All Features"
                />
                <p className="text-center mt-3 image-caption">
                  EPILYUM AI REVEAL in action - showing comprehensive skin analysis interface
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Enhanced Catalog Download Section */}
      <section className="catalog-section py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center" data-aos="fade-up">
              <h2 className="section-title mb-4">
                Download Our <span className="text-highlight">Product Catalogue</span>
              </h2>
              <p className="lead mb-5">
                Get detailed specifications and technical information about EPILYUM AI REVEAL
              </p>
              
              <div className="catalog-preview mb-5" data-aos="zoom-in">
                <div className="catalog-frame">
                  <Image 
                    src={require('../Assets/airev.png')} 
                    fluid 
                    className="catalog-thumbnail"
                    alt="Catalog Preview"
                  />
                  <div className="catalog-overlay" onClick={handleOpenPDF}>
                    <span className="overlay-text">Click to Preview</span>
                  </div>
                </div>
              </div>
              
              <button 
                onClick={handleOpenPDF}
                className="btn btn-primary btn-lg download-btn pulse"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <i className="fas fa-download me-2"></i> Download Full Catalogue (PDF)
              </button>
              
              <p className="mt-3 text-muted" data-aos="fade-up" data-aos-delay="300">
                <small>PDF File Size: 2.4MB</small>
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AISkinAnalyzer;